import { render } from "./ZNexamine.vue?vue&type=template&id=38081d08&scoped=true"
import script from "./ZNexamine.vue?vue&type=script&lang=js"
export * from "./ZNexamine.vue?vue&type=script&lang=js"

import "./ZNexamine.vue?vue&type=style&index=0&id=38081d08&lang=scss&scoped=true"
import "./ZNexamine.vue?vue&type=style&index=1&id=38081d08&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38081d08"]])

export default __exports__